import { Directive, inject } from '@angular/core';

import { MatMenu } from '@angular/material/menu';

@Directive({
  selector: '[zefSidenavMenu]',
  standalone: false,
})
export class SidenavMenu {
  readonly menu = inject(MatMenu, { self: true });
}
